import { Stack } from '@mui/material'
import { LoadingSkeleton, tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { useTranslation } from 'react-i18next'

export const MarketDataLoadingSkeleton = () => {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })

    return (
        <Stack direction="column" gap={tokens.SizingSpacing300}>
            <Stack direction="row" gap={tokens.SizingSpacing100}>
                <Typography variant="headline1" color={tokens.ColorTextBoldest}>
                    {tCommon('analysis')}
                </Typography>
            </Stack>
            <Stack direction="row" gap={tokens.SizingSpacing100}>
                <LoadingSkeleton width="114px" height="40px" sx={{ transform: 'none', borderRadius: '20px' }} />
                <LoadingSkeleton width="82px" height="40px" sx={{ transform: 'none', borderRadius: '20px' }} />
                <LoadingSkeleton width="65px" height="40px" sx={{ transform: 'none', borderRadius: '20px' }} />
                <LoadingSkeleton width="119px" height="40px" sx={{ transform: 'none', borderRadius: '20px' }} />
                <LoadingSkeleton width="86px" height="40px" sx={{ transform: 'none', borderRadius: '20px' }} />
                <LoadingSkeleton width="69px" height="40px" sx={{ transform: 'none', borderRadius: '20px' }} />
            </Stack>
            <Stack direction="column" gap={tokens.SizingSpacing500} paddingTop={tokens.SizingSpacing050}>
                <Stack direction="row" gap={tokens.SizingSpacing500}>
                    <LoadingSkeleton count={2} width={`min(50%, 573px)`} height="459px" sx={{ transform: 'none', borderRadius: '12px' }} />
                </Stack>
                <Stack direction="row" gap={tokens.SizingSpacing500}>
                    <LoadingSkeleton count={2} width={`min(50%, 573px)`} height="459px" sx={{ transform: 'none', borderRadius: '12px' }} />
                </Stack>
            </Stack>
        </Stack>
    )
}
